import { isNil, merge } from 'lodash-es';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { type ReactElement, useEffect } from 'react';
import { useState } from 'react';
import { PartnersLayout } from '../../../components/layout/PartnersLayout';
import { PartnersGuard } from '../../../components/layout/PartnersLayout/PartnersGuard';
import { PartnersSignup } from '../../../components/pages/partners/new';
import { PartnersSignupComplete } from '../../../components/pages/partners/new/complete/PartnersSignupComplete';
import type {
  Partners,
  PartnersResponse,
  PartnersWithCommissionRate,
} from '../../../components/pages/partners/new/form/types';

export const getStaticProps = async ({ locale }: { locale: string }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
  revalidate: 60,
});

/** @description 참일때 파트너스 데이터가 존재한다는것을 보장하기 위한 타입 가드 */
const hasPartners = (partners: Partners | null): partners is Partners => !isNil(partners);

export default function Page() {
  const [partners, setPartners] = useState<PartnersWithCommissionRate | null>(null);
  const isComplete = hasPartners(partners);

  const handleComplete = (response: PartnersResponse, partners: Partners) => {
    setPartners(merge(response, partners));
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [isComplete]);

  return (
    <>
      {!isComplete && <PartnersSignup onComplete={handleComplete} />}
      {isComplete && <PartnersSignupComplete partners={partners} />}
    </>
  );
}

Page.getLayout = (page: ReactElement) => (
  <PartnersLayout
    guard={PartnersGuard}
    meta={{
      title: '메타.파트너스가입.제목',
      description: '메타.파트너스가입.설명',
      pageCategory: '파트너스 가입',
    }}
  >
    {page}
  </PartnersLayout>
);
